import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import { GALLERY_TYPE } from "../types";
import { GalleryViewer } from "./gallery-viewer";
const Gallery = ({ node, nodeIndex, NodeViewContainer }) => {
  const { relValue, anchorTarget, config, seoMode, helpers, baseUrl } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    GalleryViewer,
    {
      componentData: node.galleryData || {},
      nodeId: node.id,
      settings: config[GALLERY_TYPE],
      relValue,
      anchorTarget,
      seoMode,
      helpers,
      baseUrl
    }
  ));
};
const GalleryRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Gallery, { key: node.id, node, ...props });
};
var gallery_default = GalleryRenderer;
export {
  gallery_default as default
};
//# sourceMappingURL=gallery.js.map

import "@wix/ricos/css/plugin-gallery-viewer.global.css";